import React from "react";
import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";

import OSSPod from "../OSSPod/OSSPod";
import OSBrandSafetyIcon from "../OSSBrandSafetyIcon/OSSBrandSafetyIcon";

const styles = theme => ({});

function OSSNotFound(classes) {
  return (
    <OSSPod>
      <OSSPod.Title>
        <Typography
          variant="h4"
          style={{ display: "flex", alignItems: "center" }}
        >
          <span style={{ marginRight: 5 }}>4</span>
          <OSBrandSafetyIcon width={30} fill="#007cc1" />
          <span style={{ marginLeft: 3 }}>4</span>
        </Typography>
      </OSSPod.Title>
      <OSSPod.Body>
        <Typography variant="body1" paragraph>
          The page you requested could not be found.
        </Typography>
        <Typography variant="subtitle1">
          Please double-check the URL, and contact{" "}
          <a
            style={{ color: "#2A7CB5", textDecoration: "none" }}
            href="mailto:support@openslate.com"
          >
            {" "}
            support@openslate.com
          </a>{" "}
          if you think there should be a page here. Return to the{" "}
          <Link to="/" style={{ color: "#2A7CB5", textDecoration: "none" }}>
            home page
          </Link>
          .
        </Typography>
      </OSSPod.Body>
    </OSSPod>
  );
}

export default withStyles(styles)(OSSNotFound);
